import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
const ExclamationTriangleIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <g id="outline/exclamation-triangle"><path id="Icon" d="M11.9998 9.7475V13.4975M2.69653 16.8731C1.83114 18.3731 2.91371 20.2475 4.64544 20.2475H19.3541C21.0858 20.2475 22.1684 18.3731 21.303 16.8731L13.9487 4.12562C13.0828 2.62479 10.9167 2.62479 10.0509 4.12562L2.69653 16.8731ZM11.9998 16.4975H12.0073V16.505H11.9998V16.4975Z" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" /></g>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg width={24} height={24} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default ExclamationTriangleIcon;